




import Vue from 'vue';
import OrganizationAdd from '@/components/organizations/organization-add.component.vue';

export default Vue.extend({
  components: {
    'organization-add': OrganizationAdd,
  },
});
